import { render, staticRenderFns } from "./FttbAddonsModal.vue?vue&type=template&id=2dac8df6&"
import script from "./FttbAddonsModal.vue?vue&type=script&lang=js&"
export * from "./FttbAddonsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports